import { Component, Input, OnInit } from '@angular/core';

import { NbMenuService, NbSidebarService, NbMenuItem, NbDialogService } from '@nebular/theme';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { environment } from '@env/environment';
import { HelpDialogComponent } from '@amdb/drone/shared/components';
import { AmdbAccessCheckerService } from '@amdb/drone/@core/security/amdb-access-checker.service';
const { version: appVersion } = require('../../../../../package.json');

@Component({
    selector: 'ngx-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
    @Input() position = 'normal';

    userMenu: NbMenuItem[] = [];
    user: any;
    appVersion: string;
    env = environment;

    canImpersonateAuthorities: boolean = false;

    constructor(
        private sidebarService: NbSidebarService,
        private menuService: NbMenuService,
        private authService: NbAuthService,
        private dialogService: NbDialogService,
        private accessChecker: AmdbAccessCheckerService,
    ) {
        this.appVersion = appVersion;
    }

    ngOnInit() {
        this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
            if (token.isValid()) {
                this.user = token.getPayload();

                this.canImpersonateAuthorities = this.accessChecker.canImpersonateAuthorities(this.user);
            }
        });
        this.userMenu.push({ title: 'Profils', link: '/user-profile' });
        this.userMenu.push({ title: 'Izlogoties', link: '/auth/logout' });
    }

    toggleSidebar(): boolean {
        this.sidebarService.toggle(true, 'menu-sidebar');

        return false;
    }

    goToHome() {
        this.menuService.navigateHome();
    }

    async openHelp(): Promise<void> {
        await this.dialogService.open(HelpDialogComponent).onClose.toPromise();
    }
}
